import NoEKGPreview from './NoEKGPreview'

export default NoEKGPreview



// WEBPACK FOOTER //
// ./src/legacy/components/NoEKGPreview/index.js